//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { AdvancedFilterModel } from './AdvancedFilterModel';
  
  export class FilterPageViewModel extends ModelBase {
      static readonly $typeName = 'FilterPageViewModel';
      public model: AdvancedFilterModel;
      public searchTerm: string;
      public skip: number;
      public sort: string;
      public sortDirection: string;
      public take: number;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/FilterPageViewModel.ts